// Shared bar-width geometry, reused for volume bars AND candlestick/bar/
// heikin-ashi body widths (collapsing what used to be two disagreeing
// formulas -- a full-dataset-length one in 5 of the 6 old chart files, and
// a different, viewport-aware one only in professionalTradingChart.jsx --
// into one). `visibleCount` should be the count of points currently within
// the zoomed x-domain, not the full dataset, so bars stay legible when
// zoomed into a long range instead of staying razor-thin forever.
// 2026-09-11: the comment above promised this, but every caller actually
// passed normalized.length (the FULL dataset) regardless of zoom, so
// candle width was fixed at "whatever fits ALL bars on screen" forever --
// zooming in just spread that same fixed-width candle further from its
// neighbors (thin needles with growing gaps), never grew it. Now genuinely
// wired to the count of points inside the current zoomed x-domain (see
// ChartEngine.jsx's render()), so fewer visible bars really does mean each
// one gets more of the available width -- matching TradingView. max raised
// 12 -> 48 since a handful of bars filling the whole pane should be able
// to render as fat, easy-to-read candles, not stay capped at needle width.
export function computeBarWidth({ innerWidth, visibleCount, gapRatio = 0.3, min = 1, max = 48 }) {
  const count = Math.max(1, visibleCount);
  const slot = innerWidth / count;
  return Math.min(max, Math.max(min, slot * (1 - gapRatio)));
}

export function drawVolumePane({ group, data, xScale, yScale, theme, barWidth }) {
  const bars = group.selectAll('.volume-bar').data(data, (d) => d.date);

  bars.exit().remove();

  bars
    .enter()
    .append('rect')
    .attr('class', 'volume-bar')
    .merge(bars)
    .attr('x', (d) => xScale(d.date) - barWidth / 2)
    .attr('y', (d) => yScale(d.volume))
    .attr('width', barWidth)
    .attr('height', (d) => Math.max(0, yScale(0) - yScale(d.volume)))
    .attr('fill', (d) => (d.close >= d.open ? theme.volume.bull : theme.volume.bear));
}
